<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>Post Details</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span
                @click="selected = 'Details'"
                v-if="checkPermission('list-post')"
            >
              <CTab active>
                <template slot="title">
                  {{ $lang.post.tab.details }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'PostMedia'"
                v-if="checkPermission('list-post')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.post.tab.media }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'PostResponse'"
                v-if="checkPermission('view-post-response')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.post.tab.response }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'PostReport'"
                v-if="checkPermission('view-post-report')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.post.tab.report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              style="margin-top: 20px"
              v-bind:postId="currentId"
              v-bind:profileId="profileId"
              @changeSelected="getTab($event)"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import {Mixin} from "/src/mixins/index.js";
import Details from "./tab/Details";
import PostMedia from "./tab/PostMedia";
import PostReport from "./tab/PostReport";
import PostResponse from "./tab/PostResponse";
import BackToList from "../backToList.vue";

export default {
  name: "PostView",
  mixins: [Mixin],
  components: {
    Details,
    PostMedia,
    PostReport,
    PostResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      selected: "Details",
      currentId: "",
      profileId: "",
      backToListFlag: false,
    };
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    self.userId = this.$route.params.ids;
    self.currentId = id;

    const testString = this.$router.history.current.path;
    let pathString = this.getStringBetween(testString, "all", "view");
    if (pathString !== 0) {
      // let entity = pathString.replace("/", "");
      //  localStorage.setItem("activeTab", entity);
      this.backToListFlag = this.getStringBetween(testString, "all", "view") !== 0;
    }
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: #ff0000;
}

.hasError label {
  color: red;
}
</style>

